import { useLocation } from 'react-router-dom';
import { TOOLS_CONFIG } from '../Setup/Config/tools-config';

/**
 * Hook to get the current tool's version from tools-config
 * @returns {string|null} - Tool version (e.g., 'beta', 'stable', 'alpha') or null if not found
 */
export const useToolVersion = () => {
    const location = useLocation();
    const currentPath = location.pathname;

    // Find tool by route
    const tool = TOOLS_CONFIG.find(t => t.route === currentPath);

    // Return version if tool exists, otherwise null
    return tool?.version || null;
};

